import { getType } from 'typesafe-actions';
import { produce } from 'immer';

import { User, UsersData } from 'src/components/modules/usersList/types';
import { ApiError } from 'src/api/types';

import * as usersActions from './actions';
import { ActionsOf } from '../../../helpers/actions';

const initialState: UsersData = {
  items: [],
  loading: false,
  error: false,
  success: false,
  pageNumber: 0,
  totalItems: 0,
  saving: false,
};

type UsersActions = ActionsOf<typeof usersActions>;

export const usersEntityReducer = produce((draft: UsersData, action: UsersActions) => {
  switch (action.type) {
    case getType(usersActions.getUsers.success): {
      const { result } = action.payload as { result: UsersData };

      draft.items = result.items;
      draft.pageNumber = result.pageNumber;
      draft.totalItems = result.totalItems;
      draft.loading = false;
      draft.error = false;

      return;
    }

    case getType(usersActions.getUsers.request): {
      draft.loading = true;
      draft.success = false;
      draft.error = false;

      return;
    }

    case getType(usersActions.getUsers.error): {
      draft.loading = false;
      draft.error = true;

      return;
    }

    case getType(usersActions.editUser.request): {
      draft.saving = true;
      draft.error = false;
      draft.success = false;

      return;
    }

    case getType(usersActions.editUser.error): {
      const payload = action.payload as { error?: ApiError };

      if (payload?.error?.message) {
        const errorMessage = JSON.parse(payload.error.message);
        draft.error = errorMessage[0];
      } else {
        draft.error = true;
      }

      draft.saving = false;

      return;
    }

    case getType(usersActions.editUser.success): {
      const { result } = action.payload as { result: User };
      const index = draft.items.findIndex((user) => user.userId === result.userId);

      if (index !== -1) {
        draft.items[index] = { ...draft.items[index], ...result };
      }

      draft.saving = false;
      draft.success = true;
      draft.error = false;

      return;
    }

    default:
      return;
  }
}, initialState);
